import { render, staticRenderFns } from "./CustomerListAddNew.vue?vue&type=template&id=a33a6434&"
import script from "./CustomerListAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports